'use es6';

import { getSelectedThread } from '../../selected-thread/selectors/getSelectedThread';
import { getSelectedThreadId } from '../../selected-thread/selectors/getSelectedThreadId';
import { getSessionId } from '../../selectors/widgetDataSelectors/getSessionId';
import { STUBBED_THREAD_ID } from '../../threads/constants/stubbedThreadId';
import { historyDataForThread } from '../selectors/historyDataForThread';
import { fetchThreadHistory } from './fetchThreadHistory';
import { getOffsetTimestamp, getOffsetOrdinal } from 'conversations-message-history/thread-history/operators/getters';
export const fetchOlderThreadHistory = () => (dispatch, getState) => {
  const state = getState();
  const sessionId = getSessionId(state);
  const threadId = getSelectedThreadId(state);
  if (threadId === null || threadId === STUBBED_THREAD_ID) {
    return;
  }
  const currentConversation = getSelectedThread(state);
  const threadHistory = historyDataForThread(state, {
    thread: currentConversation
  });
  const offsetOrdinal = getOffsetOrdinal(threadHistory);
  const offsetTimestamp = getOffsetTimestamp(threadHistory);
  dispatch(fetchThreadHistory({
    offsetOrdinal,
    offsetTimestamp,
    threadId,
    sessionId
  }));
};